export default __webpack_public_path__ + "static/media/carBackground.012946cb.jpg";